/** 최소 주문 수량 타입 */
export const MinOrderQtyType = {
  /** 사용 안함 */
  None: '0',
  /** 첫 주문 시에만 사용 */
  FirstOnly: '1',
  /** 모든 주문에 항상 사용 */
  Always: '2',
} as const;

export type MinOrderQtyType = (typeof MinOrderQtyType)[keyof typeof MinOrderQtyType];
